export default "__VITE_ASSET__D_QP2CaW__"